// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"6ffc34546e5c6c95","741":"fc68efa4063b70c2"}[chunkId] + ".js";
};